export enum CollectionsEnum {
  GUESTS = 'guests',
  USERS = 'users',
  RSVPS = 'rsvps',
}
